import {
  wrap,
  item,
} from './style'
import { Spacer } from 'components/Spacer'
import { Text03 } from 'components/Typography/Text03'
import { Color } from 'utils/variables'

export const InputLevel = () => {
  return (
    <>
      <Text03 color={Color.WarmGrey}>入力レベル</Text03>
      <Spacer size={13} />
      <div className={wrap}>
        {[...Array(10)].map((_, i) => {
          return <div key={i} className={`${item} volume-sLteadgse`} />
        })}
      </div>
    </>
  )
}

